export default class PhotoUrlFactory {
    private baseUrl: string;

    constructor(baseUrl: string) {
        this.baseUrl = baseUrl.replace(/\/$/, '') + '/';
    }

    public urlForMapInfoBox(photoId: string | number): string {
        return this.url(photoId, 220, 165);
    }

    public urlForList(photoId: string | number): string {
        return this.url(photoId, 60, 40);
    }

    public urlForListBig(photoId: string | number): string {
        return this.url(photoId, 300, 200);
    }

    public urlForReport(photoId: string | number): string {
        return this.url(photoId, 135, 90);
    }

    public urlForTooltip(photoId: string | number): string {
        return this.url(photoId, 400, 300);
    }

    public urlForLightbox(photoId: string | number): string {
        return this.url(photoId);
    }

    public urlForDialog(photoId: string | number): string {
        return this.url(photoId, 570, 320);
    }

    public urlForAvatar(photoId: string | number): string {
        return this.url(photoId, 40, 40);
    }

    public urlForAvatarBig(photoId: string | number): string {
        return this.url(photoId, 160, 160);
    }

    // public url(photoId: string | number, width?: number, height?: number): string {
    //     let fileParam = photoId;
    //     if (width && height) {
    //         fileParam = `crop_w${ width }_h${ height }_${ fileParam }`
    //     }
    //     return `${ this.baseUrl }/images/${ fileParam }`;
    // }

    public url(photo: string | number, width?: number, height?: number): string {
        let url = this.baseUrl + photo;
        if (width || height) {
            url += '?type=crop'
        }
        if (width) {
            url += `&width=${width}`
        }
        if (height) {
            url += `&height=${height}`
        }
        return url;
    }
}